import { mdiEyeOutline, mdiCheckCircle, mdiAlertCircle } from "@mdi/js";

export function iconForStatus(status) {
  switch (status) {
    case "unread":
      return { path: mdiEyeOutline,  css: "text-primary", tooltip: "Unread" };
    case "updated":
      return { path: mdiAlertCircle, css: "text-warning", tooltip: "Changes since you last read" };
    default:
      return { path: mdiCheckCircle, css: "text-success", tooltip: "Marked as read" };
  }
}